'use client';

import { RedeemVoucherForm } from '@components/Blocks/RedeemVoucher/RedeemVoucherForm';
import { RedeemedVoucherSuccess } from '@components/Blocks/RedeemVoucher/RedeemVoucherSuccess';
import { useRedeemVoucher } from '@components/Blocks/RedeemVoucher/useRedeemVoucher';
import { RedeemVoucherFormContent } from '@lib/types/cms/RedeemVoucherForm';
import { Banner } from '@ui-components/index';

type RedeemVoucherPageProps = {
  data: RedeemVoucherFormContent;
};

export default function RedeemVoucher({ data }: RedeemVoucherPageProps) {
  const { inputErrors, networkError, ...rest } = data;

  const {
    voucher,
    onRedeemVoucher,
    isMutating,
    networkError: networkFail,
    redeemError,
    reset,
  } = useRedeemVoucher(inputErrors);

  return (
    <div className="main-grid" data-test="redeem-voucher">
      {networkFail && !isMutating && (
        <div className="col-span-4 mb-6 md:col-span-12">
          <Banner
            title={networkError.title ?? 'Network Error'}
            description={networkError.description ?? ''}
            dismiss="dismiss"
            onDismiss={() => reset()}
          />
        </div>
      )}
      <div className="col-span-4 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
        {voucher ? (
          <RedeemedVoucherSuccess content={rest} voucher={voucher} />
        ) : (
          <RedeemVoucherForm
            onSubmitForm={onRedeemVoucher}
            errorMessage={redeemError}
            isSubmitting={isMutating}
            content={rest}
          />
        )}
      </div>
    </div>
  );
}
